import {Injectable} from '@angular/core';
import {AlarmType} from '../model/alarm-type.model';
import {ApiService} from './api.service';
import {retryAfterMillis} from '../shared/constants';
import {isString, utf8Decode} from 'sdv-common';

@Injectable({providedIn: 'root'})
export class AlarmTypeService {

  private colors = {
    system: {
      red: 255,
      green: 186,
      blue: 186,
      alpha: .5
    },
    info: {
      red: 189,
      green: 229,
      blue: 248,
      alpha: .5
    },
    warning: {
      red: 254,
      green: 239,
      blue: 179,
      alpha: .5
    },
    error: {
      red: 255,
      green: 204,
      blue: 186,
      alpha: .5
    },
    success: {
      red: 223,
      green: 242,
      blue: 191,
      alpha: .5
    },
    timing: {
      red: 239,
      green: 239,
      blue: 239,
      alpha: .5
    }
  };
  private types: AlarmType[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('alarm-types', {
      $limit: 1000,
      $offset: 0
    }).subscribe(response => {
      const types: AlarmType[] = [];
      for (const alarmType of response) {
        types.push(this.covertAlarmType(alarmType));
      }
      this.types = types;
    }, err => {
      this.apiService.error({}, err);
      setTimeout(() => this.load(), retryAfterMillis);
    });
  }

  private covertAlarmType(alarmType) {
    return {
      id: alarmType.id || 0,
      system: alarmType.system,
      thymeleaf: utf8Decode(alarmType.name || '')
    };
  }

  getTypes() {
    return this.types;
  }

  getColorByTypeId(typeId) {
    switch (typeId) {
      case 1:
        return this.colors.system;
      case 2:
        return this.colors.info;
      case 3:
        return this.colors.warning;
      case 4:
        return this.colors.error;
      case 5:
        return this.colors.success;
      case 6:
        return this.colors.timing;
      default:
        throw new Error('Unsupported alarm type identifier ' + typeId);
    }
  }

  get(id) {
    if (isString(id)) {
      id = parseInt(id);
    }
    for (const type of this.getTypes()) {
      if (type.id === id) {
        return type;
      }
    }
    return {
      id,
      system: true,
      thymeleaf: id
    };
  }
}
